import {
  History,
  HistoryBorder,
  HistoryEvent,
  HistoryEventContent,
  HistoryEventDate,
  HistoryEventIcon,
  HistoryEventTextualContent,
  HistoryEventTitle,
} from "@babackapp/ui/components/history";
import { formatDate } from "date-fns/format";
import { CalendarIcon, LoaderIcon } from "lucide-react";
import { tLayout } from "../../translations";
import { TrackingHistoryBlockProps } from "./types";
import { getTrackingStatusTranslation, TrackingStatus as TrackingStatusEnum } from "@babackapp/tracking-status-registry";

export function TrackingHistoryWeb(props: TrackingHistoryBlockProps) {
  const { parcel, locale, defaultLocale } = props;
  const t = tLayout(locale, defaultLocale);

  if (!parcel || !parcel.events || !Array.isArray(parcel.events)) return null;

  const events = [...parcel.events].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  return (
    <div className="mt-6">
      <span className="text-xs text-muted-foreground font-medium">
        {t("parcel-history")}
      </span>
      <History className="mt-4">
        {events.map((event, index) => (
          <HistoryEvent key={event.createdAt}>
            {index !== events.length - 1 && <HistoryBorder />}
            <HistoryEventIcon
              className={
                index === 0
                  ? "bg-primary border-primary text-primary-foreground"
                  : ""
              }
            >
              <CalendarIcon className="size-4" />
            </HistoryEventIcon>
            <HistoryEventContent>
              <HistoryEventTitle>
                <TrackingStatus locale={locale} status={event.status as TrackingStatusEnum} />{" "}
                {index === 0 && <LoaderIcon />}
              </HistoryEventTitle>
              <HistoryEventDate>
                {formatDate(event.createdAt, "dd MMM yyyy")}
              </HistoryEventDate>
              <HistoryEventTextualContent>
                <TrackingStatusDescription
                  status={event.status as TrackingStatusEnum}
                  locale={locale}
                />
              </HistoryEventTextualContent>
            </HistoryEventContent>
          </HistoryEvent>
        ))}
      </History>
    </div>
  );
}

type TrackingStatusProps = {
  status: TrackingStatusEnum;
  locale: string;
};

export function TrackingStatus({ locale, status }: TrackingStatusProps) {
  return getTrackingStatusTranslation(status, locale).title;
}

type TrackingStatusDescriptionProps = {
  status: TrackingStatusEnum;
  locale: string;
};

export function TrackingStatusDescription({
  status,
  locale,
}: TrackingStatusDescriptionProps) {
  return getTrackingStatusTranslation(status, locale).description;
}
